module.exports = __webpack_public_path__ + "static/media/rotate.4d9c8078.gif";